




















































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import PlantPicker from "@/view/shared-components/PlantPicker.vue";
import Plant from "@/domainObjects/Plant";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import TicketService from "@/services/TicketService";
import Fields from "@/domainObjects/Fields";
import LoadingActions from "@/store/actions/loading";


@Component({
    name: 'HoldTicketTable',
    components:{
        PlantPicker
    },
})
export default class HoldTicketTable extends Vue {
    @Prop({required: false}) updatedTicket!: HoldTicket;
    @Prop({required: false}) updatedTicketType!: string;
    @Prop({required: false}) newTicketsFromActionTracker!: HoldTicket[];

    @Watch('$route')
    onPropertyChanged(to, from){
        if (to.name === 'hold-tickets'){
            this.fetchHoldTickets();
        }
    }

    private holdTickets:HoldTicket[] = [];
    private allHoldTickets:HoldTicket[] = [];
    private fields:Fields[] = [];
    private activeTickets:number = 0;
    private currentPage:number = 0;
    private perPage:number = 0;
    private totalRows:number = 0;
    private filter:string = '';
    private hover:boolean = true;
    private pageOptions:number[] = [];
    private sortBy: string = '';
    private sortDesc: boolean = true;
    private isBusy = true;
    private unsecureServerUrl:string = '';
    private serverUrl: string = '';
    private plant: Plant = new Plant();
    private tableLayout: boolean = false;
    private windowWidth: number = 0;
    private ticketsLoaded: boolean = false;

    constructor() {
        super();
        this.fetchHoldTickets();
        this.unsecureServerUrl = TicketService.getUnsecureServerUrl();
        this.serverUrl = TicketService.getServerUrl();
        this.fields = [
            { key: 'holdTicketId', label: 'Ticket #', sortable: true, sortDirection: 'desc' },
            { key: 'status.desc', label: 'Status', sortable: true, sortDirection: 'desc'},
            { key: 'productionOrderNum', label: 'Order Number', sortable: true, sortDirection: 'desc' },
            { key: 'cparNumber', label: 'CAPA #', sortable: true, sortDirection: 'desc'},
            { key: 'comments', label: 'Desc. of Non-conf', sortable: true, sortDirection: 'desc'},
            { key: 'quantityOnHold', label: 'QTY', sortable: true, sortDirection: 'desc'},
            { key: 'materialDesc', label: 'Material Description', sortable: true, sortDirection: 'desc' },
            { key: 'disposition.desc', label: 'Disposition', sortable: true, sortDirection: 'desc' },
            { key: 'dispositionComments', label: 'Action Req', sortable: true, sortDirection: 'desc' },
            { key: 'daysOpen', label: 'Days Open', sortable: true, sortDirection: 'desc'},
            { key: 'plant.desc', label: 'Plant', sortable: true, sortDirection: 'desc' },
            { key: 'salesOrderNumber', label: 'Sales Order Number', sortable: true, sortDirection: 'desc'},
            { key: 'actions', label: 'Options', sortable: false, sortDirection: 'desc' }
        ];
        this.currentPage = 1;
        this.perPage = 25;
        this.totalRows = this.holdTickets.length;
        this.filter = "";
        this.hover = true;
        this.pageOptions = [ 5, 10, 25, 50, 100 ];
        this.sortBy = 'holdTicketId';
        this.sortDesc = true;
    }

    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    destroyed(){
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize(){
        this.tableLayout = window.innerWidth < 992;
        this.windowWidth = window.innerWidth;
    }

    onFiltered( filteredItems ) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
    }

    fetchHoldTickets() {
        this.$store.dispatch(LoadingActions.LOADING, true);
        this.holdTickets = [];
        this.isBusy = true;
        TicketService.getHoldTickets().then((response) => {
            for ( let readHoldTicket of response.data ) {
                let ticket = new HoldTicket();
                ticket.initFromObject(readHoldTicket);
                this.holdTickets.push(ticket);
            }
            this.allHoldTickets = this.holdTickets;
            this.activeTickets = this.holdTickets.length;
            if (this.plant){
                this.filterByPlant(this.plant);
            }
            this.isBusy = false;
            this.ticketsLoaded = true;
            this.$store.dispatch(LoadingActions.LOADING, false);
        }).catch((error)=>{

        });
    }

    filterByPlant(value){
        if (value.code == 0){
            this.holdTickets = this.allHoldTickets;
        } else {
            this.holdTickets = this.allHoldTickets.filter(ticket => ticket.plant.code === value.code);
        }
        this.activeTickets = this.holdTickets.length;
        this.plant = value;
    }

    changeLayout(){
        this.tableLayout = !this.tableLayout;
    }

    addTicket(){
        // @ts-ignore
        this.$router.push({ name: 'add-hold-ticket', params: {plant: this.plant}})
    }

    forceRefresh(){
        //this.plant = new Plant();
        this.filter = "";
        this.fetchHoldTickets();
    }
}

